import { render, staticRenderFns } from "./ProtocoloSearchForm.vue?vue&type=template&id=68d62d6d&scoped=true&"
import script from "./ProtocoloSearchForm.vue?vue&type=script&lang=js&"
export * from "./ProtocoloSearchForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d62d6d",
  null
  
)

export default component.exports